<template>
  <div>
    <div v-if="hasFinding">
      <p
        class="caption mt-4 pa-0 green--text text--darken-2 d-flex align-center"
      >
        <v-icon class="mr-2" small color="green">
          mdi-check-circle
        </v-icon>

        {{ $t('routines.checklist_finding_created') }}
      </p>
      <Button
        outlined
        size="small"
        :text="$t('routines.view_finding')"
        @click="$emit('viewFinding')"
      />
    </div>
    <div v-else>
      <p
        class="caption mt-4 pa-0 amber--text text--darken-2 d-flex align-center"
      >
        <v-icon class="mr-2" small color="amber darken-2">
          mdi-alert-circle
        </v-icon>

        {{ $t('routines.checklist_require_finding') }}
      </p>
      <Button
        outlined
        size="small"
        :text="$t('routines.create_finding')"
        @click="$emit('openCreateFindingModal')"
      />
    </div>
  </div>
</template>

<script>
import Button from '@/components/UI/Button'

export default {
  name: 'ChecklistFindingFooter',

  components: {
    Button,
  },

  props: {
    hasFinding: {
      type: Boolean,
      required: true,
      default: () => false,
    },
  },
}
</script>
